import PropTypes from 'prop-types';
import React from 'react';

import Popups from '../../components/Popup';
import { usePopupContext } from '../../contexts/PopupContext';

const ErrorPopupContainer = ({ popup }) => {
  const { closePopup } = usePopupContext();

  return (
    <Popups.ErrorPopup
      error={popup.getIn(['props', 'error'])}
      formError={popup.getIn(['props', 'formError'])}
      onClose={closePopup}
    />
  );
};

ErrorPopupContainer.propTypes = {
  popup: PropTypes.object.isRequired,
};

export default ErrorPopupContainer;
